<template>
  <MainLayout>
    <template #toolbar>
      <Shortcuts
        :main-shortcut="''"
        :shortcuts="['budget','create_advertiser','create_campaign']"
      />
    </template>
    <template>
      <!--begin::Page title-->
      <div class="d-flex text-uppercase text-center justify-content-center align-items-center mt-5 mb-1" :class="step === 'newDashboard'? 'd-flex flex-column' : ''">
        <div class="d-flex flex-row">
          <BaseIcon size="small">
            <ReportIcon />
          </BaseIcon>
          <h1 class="text-center fw-bold ms-5 mb-0">
            {{ step === 'dashboard' ? $t('dashboards') : $t('advantages_of_using_the_dashboard') }}
          </h1>
        </div>
        <p v-if="step === 'newDashboard'" class="text-center">{{ $t('some_of_the_advantages_of_using_the_dashboard') }}</p>
      </div>
      <!-- DASHBOARDS -->
      <div class="d-flex justify-content-center">
        <div class="mt-4" :class="step === 'newDashboard' ? 'w-75' : 'w-100'">
          <div class="d-flex justify-content-end mb-4" v-if="step !== 'questions_about_dashboards' && !localListTableLoader">
            <Button
              class="btn-sm ms-1 btn-color1"
              @click="step == 'newDashboard' ? setStep('dashboard') : setStep('newDashboard')"
            > {{ step == 'newDashboard' ? $t('view_dashboards') : $t('request_your_dashboard_here') }} </Button>
          </div>
          <div v-if="step == 'newDashboard'">
            <AlertWraper
              :content="content"
              :type="content_type"
            />
            <div class="mt-3 default-form">
              <form class="default-form" @submit.prevent="">
                <div class="mt-3">
                  <p class="text-left">{{ $t('advantages_dashboard') }}</p>
                </div>
                <div class="mt-4 mb-3">
                  <h6 class="text-left">{{ $t('request_dashboard_select_advertiser') }}</h6>
                </div>
                <!-- ADVERTISER -->
                <template class="form-group">
                  <label class="form-label fw-bold">
                    {{ $t('advertiser') }}*
                  </label>
                  <div v-if="advertisersLoader" class="mb-5">
                    <Loader
                      :size="'small'"
                      :align="'center'"
                    />
                  </div>
                  <template v-else>
                    <div class="custom-select">
                      <select
                        class="form-control"
                        v-model.trim="form.advertiser_id"
                        @change="selectedAdvertiser"
                      >
                        <option disabled="true" selected="true">{{ $t('select') }}</option>
                        <template v-if="advertisers.length > 0">
                          <option v-for="(lAdvertiser, index) in advertisers" :key="index" :value="lAdvertiser.id">{{ lAdvertiser.name }}</option>
                        </template>
                      </select>
                    </div>
                    <p
                      class="font-size-xSmall fw-bold mt-2 error-message-card"
                      v-if="selectedAdvertiser && selectedAdvertiser.status === 'ERROR'"
                    >
                      {{ $t('advertiser_creation_issue_access_page_try_again', {name:selectedAdvertiser.name}) }}
                    </p>
                  </template>
                </template> <!-- END ADVERTISER -->
                <div class="mt-4 text-center">
                  <Button
                    class="btn btn-color10"
                    @click="submit"
                    :loading="loader"
                    :disabled="!form.advertiser_id"
                  >
                    {{ $t('request_dashboard') }}
                  </Button>
                </div>
              </form>
            </div>
          </div>
          <div v-else-if="step == 'questions_about_dashboards'">
            <div class="mt-3 default-form">
              <form class="default-form" @submit.prevent="">
                <iframe src="https://scribehow.com/embed/Acesse_seu_Dashboard_dentro_da_Pixel_Roads__d6k_SpnlQFGzkvOISMar8Q" width="100%" height="650" allowfullscreen frameborder="0"></iframe>
                <div class="mt-3 text-center">
                  <Button
                    class="btn btn-color10"
                    @click="setStep('dashboard')"
                  >
                    {{ $t('back') }}
                  </Button>

                </div>
              </form>
            </div>
          </div>
          <template v-else>
            <DashboardListTable
              :reload="reload"
              @loaderListTable="loaderListTable"
            />

            <div class="my-10">
              <div class="mx-2">
                <h2> {{ $t('dashboards_by_advertiser')}} </h2>
                <p> {{$t('new_dashboards.description')}} </p>
              </div>
              <template v-if="advertisersLoader">
                <Loader
                  :size="'big'"
                />
              </template>
              <template v-else>
                <AdvertiserDashboardListTable
                  class="my-5"
                  :advertisers="advertisers"
                  :reload="reload"
                  @loaderListTable="loaderListTable"
                />
              </template>
            </div>
          </template>
        </div> <!-- END DASHBOARDS -->
      </div>
    </template>
  </MainLayout>
</template>

<script>

import AdvertisersService from '@/modules/advertisers/services/advertisers-service'
import DashboardsService from '@/modules/dashboards/services/dashboards-service'
import NotificationService from '@/modules/notifications/services/notifications-service'

import AlertWraper from '@/components/common/Alert/AlertWraper'
import BaseIcon from '@/components/common/Icon/BaseIcon'
import Button from '@/components/common/Button/Button'
import DashboardListTable from '@/components/dashboards/DashboardListTable'
import Loader from '@/components/common/Loader/Loader'
import MainLayout from '@/components/layouts/MainLayout'
import { mapState } from 'vuex'
import { parseErrorResponseToArray } from '@/utils'
import ReportIcon from '@/components/common/Icon/ReportIcon'
import Shortcuts from '@/components/common/Shortcuts/Shortcuts'
import AdvertiserDashboardListTable from '@/components/advertisers/AdvertiserDashboardListTable'

export default {
  components: {
    AdvertiserDashboardListTable,
    AlertWraper,
    Button,
    BaseIcon,
    DashboardListTable,
    Loader,
    MainLayout,
    ReportIcon,
    Shortcuts
  },
  data () {
    return {
      advertisers: [],
      advertisersLoader: false,
      content: null,
      content_type: 'success',
      form: {
        advertiser_id: ''
      },
      loader: false,
      localListTableLoader: this.loaderListTable,
      reload: false,
      step: 'dashboard'
    }
  },
  created () {
    this.getAdvertisers()
  },
  metaInfo () {
    return {
      title: this.$t('dashboards')
    }
  },
  watch: {
    'form.advertiser_id' (newValue) {
      this.form.advertiser_id = newValue
    }
  },
  computed: {
    ...mapState('users', {
      user: state => state.user
    })
  },
  methods: {
    /**
     * Get advertisers
     */
    async getAdvertisers () {
      this.advertisersLoader = true
      try {
        const advertisers = await AdvertisersService.getAdvertisers({
          companyId: this.user.company.id,
          itemsPerPage: 100,
          viewType: 'default'
        })
        this.advertisers = advertisers.data
      } catch (error) {
        error.handleGlobally && error.handleGlobally()
      }
      this.advertisersLoader = false
    },
    /**
     * Handle upsert
     */
    handleUpsert (dashboard) {
      this.$router.push({ name: 'dashboards.show', params: { id: dashboard.id } })
    },
    /**
     * loader list table
     */
    loaderListTable (newValue) {
      this.localListTableLoader = newValue
    },
    /**
     * Reload dashboards
     */
    reloadDashboards () {
      this.reload = true
      setTimeout(() => {
        this.reload = false
      }, 300)
    },
    /**
     * Selected advertiser
     */
    selectedAdvertiser () {
      if (!this.form.advertiser_id) return null
      return this.advertisers.find(item => {
        return item.id === this.form.advertiser_id
      })
    },
    /**
     * set step audiences or favorite audiences
     * @param step
     */
    setStep (step) {
      switch (step) {
        case 'dashboard':
          this.step = 'dashboard'
          break
        case 'newDashboard':
          this.step = 'newDashboard'
          break
      }
    },
    /**
     * Submit form
     */
    async submit () {
      this.loader = true

      try {
        const response = await DashboardsService.requestDashboard({
          advertiserId: this.form.advertiser_id
        })
        this.content = response.message

        const notification = {
          notification: {
            type: 'success',
            content: this.$t('request_dashboard_success_message')
          }
        }
        NotificationService.createGlobalSuccessNotification(notification)
        this.$bvModal.hide('request-dashboard-modal')
      } catch (error) {
        this.content_type = 'error'
        this.content = parseErrorResponseToArray(error)
      }
      this.loader = false
    }
  }
}
</script>
